import a from "react";
import { getIconColor as i } from "./iconfont.es5470.js";
import h from "./iconfont.es5471.js";
const m = {
  display: "block"
}, g = ({ size: t = 16, useVw: e, useRem: c, color: o, withColor: l, removeClassName: n, disableSSR: d, style: r, ...p }) => {
  const x = r ? { ...m, ...r } : m;
  return /* @__PURE__ */ a.createElement(h, { disableSSR: d }, /* @__PURE__ */ a.createElement("svg", { "data-icon-id": "24px-kaquanzhongxin", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 24 24", width: e ? ((t || 0) / 375 * 100).toFixed(5) + "vw" : t + (c ? "rem" : "px"), height: e ? ((t || 0) / 375 * 100).toFixed(5) + "vw" : t + (c ? "rem" : "px"), className: n ? "" : "iconpark-icon", style: x, fill: "none", ...p }, /* @__PURE__ */ a.createElement(
    "g",
    {
      className: n ? "" : "24px-å¡å¸ä¸­å¿"
    },
    /* @__PURE__ */ a.createElement(
      "g",
      {
        className: n ? "" : "normal",
        fill: l ? i(o, 0, "#262933") : "#262933",
        datafollowfill: l ? i(o, 0, "#262933") : "#262933"
      },
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M4.004 5.188a1.18 1.18 0 0 0-1.18 1.18v2.555s0 .007.004.017a.22.22 0 0 0 .034.056.53.53 0 0 0 .198.149c.385.175.848.47 1.216.96.376.501.618 1.16.618 1.995 0 1.707-1.213 2.606-1.922 2.983-.057.03-.1.07-.125.107-.023.033-.023.052-.023.052v2.39c0 .652.529 1.18 1.18 1.18H14.08a.8.8 0 0 1 0 1.6H4.004a2.78 2.78 0 0 1-2.78-2.78v-2.39c0-.737.482-1.298.998-1.572.516-.275 1.072-.753 1.072-1.57 0-.508-.14-.826-.297-1.035a1.529 1.529 0 0 0-.599-.464c-.551-.25-1.174-.832-1.174-1.678V6.368a2.78 2.78 0 0 1 2.78-2.78h15.994a2.78 2.78 0 0 1 2.78 2.78V8.99c0 .784-.543 1.341-1.01 1.618-.325.192-.763.586-.763 1.492 0 .931.464 1.361.81 1.574.457.282.963.832.963 1.588v2.37a2.78 2.78 0 0 1-2.78 2.78h-1.556a.8.8 0 0 1 0-1.6h1.556a1.18 1.18 0 0 0 1.18-1.18v-2.37s0-.006-.004-.016a.226.226 0 0 0-.028-.054.575.575 0 0 0-.171-.156c-.689-.424-1.57-1.313-1.57-2.936 0-1.591.849-2.455 1.548-2.869a.63.63 0 0 0 .19-.167.242.242 0 0 0 .031-.057c.004-.012.004-.017.004-.017V6.368a1.18 1.18 0 0 0-1.18-1.18H4.004Z"
        }
      ),
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M8.715 14.351a.8.8 0 0 1 .8-.8h4.972a.8.8 0 1 1 0 1.6H9.515a.8.8 0 0 1-.8-.8Zm.8-5.502a.8.8 0 0 0 0 1.6h4.972a.8.8 0 0 0 0-1.6H9.515Z"
        }
      )
    )
  )));
}, E = g;
export {
  E as default
};
